import * as Sentry from '@sentry/browser'
import * as React from 'react'
import { defineMessages, FormattedMessage } from 'react-intl'
import { Helmet } from 'react-helmet'

import DooerLive from '../../sections/dooer-live'
import Footer from '../../sections/footer'

import styles from './error-boundary.module.scss'

export const messages = defineMessages({
  heading: {
    defaultMessage: 'Hoppsan! Något gick fel.',
    id: 'error-boundary.heading',
  },
})

interface IErrorBoundaryState {
  error: Error | null
}

// eslint-disable-next-line @typescript-eslint/ban-types
export default class ErrorBoundary extends React.Component<{}, IErrorBoundaryState> {
  // eslint-disable-next-line @typescript-eslint/ban-types
  constructor(props: {}) {
    super(props)

    this.state = { error: null }
  }

  componentDidCatch(error: Error) {
    Sentry.captureException(error)
  }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  render() {
    if (this.state.error) {
      return (
        <>
          <Helmet>
            <title>{'404 Sidan finns inte | Dooer'}</title>
          </Helmet>

          <div className={styles.root}>
            <h1 className={styles.heading}>
              <FormattedMessage {...messages.heading} />
            </h1>
          </div>

          <DooerLive inverted />

          <Footer />
        </>
      )
    }

    return this.props.children || null
  }
}
